export default {
  "/financeService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/reviewService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/inceptionService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/craftService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/adPreviewSvc": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/launcherStrategySvcV2": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/changeHistoryService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/adwordsAccessorService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/campaignLauncher": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/changeLogDbService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/changeLogDbServiceV2": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/clientInputService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/configurationDbService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/creativeUploadService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/geoTargetingService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/goalValidatorServiceV2": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/hadesV2": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/intercom_events": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/intercomEvents": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/irisExecService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/kibanaUI": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/marketingCampaignsDbSvc": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/marketingCampaignServiceV2": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/ninkasiService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/notificationsServiceV2": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/notificationsService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/onboardingService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/osBulkActionsService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/osBillingServiceV2": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/osBillingService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/propertySettingsSvcV2": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/reportingUISvc/mediaLibrary": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/reportingSvc": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/merchandiseFeedService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/nexusService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/reportingUISvc": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/shopsUIService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/sokratiLiveService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/stripeAccessorService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/suggestionDbSvc": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/tagsRetrofittingSvc": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/ttyaService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/uploaderSvc": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/watchlistService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/osAdsService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/sokratiShopsService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/onBoardingSvcV2": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/merchandiseDbSvc": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/osGravitiService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/marketplaceService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/marketplace": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/leadManagementService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/neonService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/videoXService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/eventManagerServiceV2": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/brandAdsUIService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/commentsService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/adCardService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/starkService": {
    target: "https://osx-staging.onlinesales.ai",
  },
  "/keywordTargetingService": {
    target: "https://osx-staging.onlinesales.ai",
  },
};
